import { lazy, ReactNode, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { FullscreenLoader } from '@/components'
import { ROUTES } from './routes'

/**
 * Lazy-load page modules so each route ships its own bundle.
 *
 * To add a new page:
 *   1. Add a key + path to `ROUTES` in `./routes.ts`.
 *   2. Create the module under `src/modules/<PageName>/`.
 *   3. Add a thin entry at `src/pages/<path>/index.tsx` that renders the module.
 *   4. Add a `lazy(() => import('@/pages/<path>'))` line below.
 *   5. Add a `<Route>` inside `<Routes>` with `element={<Page />}`.
 */
const HomePage = lazy(() => import('@/pages/home'))
const AuthPage = lazy(() => import('@/pages/auth'))
const ProfilePage = lazy(() => import('@/pages/profile'))
const SamplePage = lazy(() => import('@/pages/sample'))

interface AppRouterProps {
  fallback?: ReactNode
}

export default function AppRouter({ fallback }: AppRouterProps = {}) {
  return (
    <BrowserRouter>
      <Suspense fallback={fallback ?? <FullscreenLoader open />}>
        <Routes>
          <Route path={ROUTES.HOME} element={<HomePage />} />
          <Route path={ROUTES.LOGIN} element={<AuthPage />} />
          <Route path={ROUTES.SIGNUP} element={<AuthPage />} />
          <Route path={ROUTES.PROFILE} element={<ProfilePage />} />
          <Route path={ROUTES.SAMPLE} element={<SamplePage />} />
          <Route path={ROUTES.NOT_FOUND} element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
